import { afterNextRender, effect, inject, Injector, runInInjectionContext } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl, NgControl } from '@angular/forms';

export const formControlStatusSyncEffect = (control: AbstractControl) => {
  const injector = inject(Injector);
  return afterNextRender(() => {
    runInInjectionContext(injector, () => {
      const ngControl = inject(NgControl, { optional: true });
      const formControl = control;
      const parentControl = ngControl?.control;
      if (!ngControl || !parentControl) {
        return;
      }

      const status = toSignal(parentControl.statusChanges);
      const keepFormControlInSync = effect(() => {
        status();
        if (formControl.touched || ngControl.touched) {
          parentControl.markAsTouched();
        }
        if (formControl.dirty) {
          parentControl.markAsDirty();
        }
        // if (ngControl.errors) {
        //   formControl.setErrors(ngControl.errors);
        // }
        // if (ngControl.validator) {
        //   const validators: ValidatorFn[] = [];
        //   if (formControl.validator) {
        //     validators.push(formControl.validator);
        //   }
        //   if (parentControl.validator) {
        //     validators.push(parentControl.validator);
        //   }
        //
        //   parentControl.setValidators(validators);
        // }
      });
    });
  });
};
